import { Typography } from "antd";
import { CloseOutlined, FilePdfOutlined } from "@ant-design/icons";

const { Text } = Typography;

export default function UploadedCard({ file, fileName, onRemove }) {
    const displayName = file?.name || fileName || "Unknown file";
    const displaySize = file?.size ? (file.size / 1024).toFixed(2) : "Unknown";

    if (!file && !fileName) return null;

    return (
        <div
            style={{
                border: "1px dashed #d9d9d9",
                borderRadius: 8,
                padding: "32px 16px",
                background: "#fafafa",
                textAlign: "center",
                position: "relative",
            }}
        >
            <CloseOutlined
                onClick={onRemove}
                style={{
                    position: "absolute",
                    right: 12,
                    top: 12,
                    fontSize: 14,
                    cursor: "pointer",
                    color: "#999",
                    transition: "color 0.2s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#ff4d4f")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#999")}
            />

            <FilePdfOutlined
                style={{
                    fontSize: 40,
                    color: "#00998E",
                    marginBottom: 16,
                }}
            />

            <Text
                strong
                style={{
                    fontSize: 15,
                    display: "block",
                    marginBottom: 4,
                    wordBreak: "break-word",
                    color: "#262626",
                }}
            >
                {displayName}
            </Text>

            {file?.size && (
                <Text
                    style={{
                        display: "block",
                        marginBottom: 12,
                        fontSize: 13,
                        color: "#8c8c8c",
                    }}
                >
                    {displaySize} KB
                </Text>
            )}

            <Text style={{ fontSize: 13, color: "#595959" }}>
                Click{" "}
                <Text strong style={{ color: "#262626" }}>
                    Next
                </Text>{" "}
                to continue.
            </Text>
        </div>
    );
}
